var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Rayon")]),_vm._l((_vm.statItems),function(ref){
var radius = ref.radius;
var stats = ref.stats;
return _c('div',{key:radius},[_c('h4',[_vm._v(_vm._s(radius)+" km")]),_c('stats-list',{attrs:{"items":stats}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }